const RELOAD_STAMP_KEY = "asseteye-stale-chunk-reload-at";
const RELOAD_COOLDOWN_MS = 30000;

export const isStaleChunkError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || "");

export const reloadOnceForStaleChunk = (
  error,
  {
    storage = window.sessionStorage,
    reload = () => window.location.reload(),
    now = Date.now(),
  } = {},
) => {
  if (!isStaleChunkError(error)) return false;
  try {
    const lastReload = Number(storage.getItem(RELOAD_STAMP_KEY));
    if (lastReload && now - lastReload < RELOAD_COOLDOWN_MS) return false;
    storage.setItem(RELOAD_STAMP_KEY, String(now));
  } catch {
    return false;
  }
  reload();
  return true;
};
